import { render, staticRenderFns } from "./DialogAddMessage.vue?vue&type=template&id=917e704a"
import script from "./DialogAddMessage.vue?vue&type=script&lang=js"
export * from "./DialogAddMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports